import { ReduxWrapper } from '../app.state';
import { TokenBalance } from 'src/app/services/licenses/licenses.model';

export interface TokensState {
    tokenBalance?: TokenBalance | null;
    tokenSummary: { current: number | null; total: number | null; percent: number };
}

export const tokensValueInitial: TokensState = {
    tokenBalance: null,
    tokenSummary: { current: null, total: null, percent: 0 }
};

export const tokensInitialState: ReduxWrapper<TokensState | undefined> = {
    error: undefined,
    loading: false,
    loadedOnce: false,
    value: tokensValueInitial
};
